import React from 'react';
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { dollarsToCents, centsToDollars } from '@/utils/money';

interface PriceFieldProps {
  form: UseFormReturn<any>;
}

export const PriceField: React.FC<PriceFieldProps> = ({ form }) => {
  // Convert price_cents to price_dollars for display
  React.useEffect(() => {
    const cents = form.getValues('price_cents');
    if (cents !== undefined) {
      form.setValue('price_dollars', centsToDollars(cents));
    }
  }, [form]);

  return (
    <FormField
      control={form.control}
      name="price_dollars"
      render={({ field }) => (
        <FormItem>
          <FormLabel>Price ($)</FormLabel>
          <FormControl>
            <Input 
              {...field} 
              type="number" 
              step="0.01" 
              min="0" 
              placeholder="0.00" 
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};

// NOTE: Ensure parent form converts price_dollars to price_cents on submit using dollarsToCents.
